import { useEffect } from 'react';

/**
 * The searching interstitial. It is theatre — nothing is actually fetched,
 * because the offers are static — but it is the design's pacing between the
 * last question and the results, and it gives the answers a moment to feel
 * like they were used.
 *
 * `prefers-reduced-motion` stops the spin in CSS; the delay still elapses, so
 * the flow never depends on an animation having run.
 */
const HOLD_MS = 2200;

export default function LoaderStep({ onDone }) {
  useEffect(() => {
    const timer = setTimeout(onDone, HOLD_MS);
    return () => clearTimeout(timer);
  }, [onDone]);

  return (
    <div className="loader">
      <span className="loader__ring" aria-hidden="true" />
      <span className="visually-hidden" role="status">
        Searching for offers, please wait.
      </span>
    </div>
  );
}
